import React from "react";
import { Animate, motion } from "framer-motion";
import Image from "next/image";
import Swal from "sweetalert2";
export default function PlayButton() {
  //   const path = "M10,60 C10,90 90,90 90,10";
  const pathVariants = {
    move: {
      pathLength: 1,
      transition: { duration: 1 },
    },
  };
  function showVideoModal() {
    const isMobileDevice = window.innerWidth <= 768; // Adjust the breakpoint as needed

    Swal.fire({
      html: `
        <div class="video-container">
          <iframe 
            src="https://www.youtube.com/embed/26aFZbBaXZA"  
            frameborder="1" 
            allowfullscreen
            title="Embedded post"
          ></iframe>
        </div>
      `,
      showCloseButton: true,
      focusConfirm: false,
      width: isMobileDevice ? "100%" : "970px",
      heightAuto: true,
      showConfirmButton: false,
      background: "black",
      position: "center",
      // Custom Class to style the video container
      customClass: {
        container: "video-modal-container",
      },
    });
  }

  return (
    <>
      <button
        onClick={showVideoModal}
        className="relative mds:h-[200px] mds:w-[200px] h-[100px] w-[100px]  flex items-center justify-center mx-auto "
      >
        <motion.div
          className="absolute border-dashed border mx-auto mds:w-[326px] mds:h-[326px] h-[170px] w-[170px] no-scrollbar flex justify-center items-center border-[#BE72F3]"
          animate={{
            //   scale: [1, 1, 1, 1, 1],
            rotate: [0, 360],
            borderRadius: ["50%", "50%", "50%", "50%", "50%"],
          }}
          transition={{
            duration: 8,
            ease: "linear",
            times: [1],
            repeat: Infinity,
            repeatDelay: 0,
          }}
        >
          <motion.div
            className=" mds:h-44 mds:w-44 h-24 w-24 absolute rounded-full"
            style={{ border: "2px solid #BE72F3", opacity: "0.06" }}
            animate={{
              scale: [1, 2.2, 1],
              transition: {
                duration: 5,
                ease: "easeInOut",
                repeat: Infinity,
                repeatDelay: 0,
              },
            }}
          />

          <motion.div
            className="mds:h-32 mds:border-[6px] border-[4px] border-[#BE72F3] mds:w-32 w-16 h-16 absolute  rounded-full"
            style={{ opacity: "0.03" }}
            animate={{
              scale: [1, 2.2, 1],
              transition: {
                duration: 5,
                ease: "easeInOut",
                repeat: Infinity,
                repeatDelay: 0,
              },
            }}
          />
          <motion.div
            className="mds:w-[204px]  mds:h-[204px] w-[104px] h-[104px]  z-50 p-6 rounded-full flex items-center justify-center"
            animate={{
              scale: [0.8, 1, 0.8],
              transition: {
                duration: 4,
                ease: "easeInOut",
                repeat: Infinity,
                repeatDelay: 0,
              },
            }}
          >
            <motion.div
              className="
              bg-white 
              mds:shadow-[0_10px_40px_10px_rgba(193,131,243,0.2)]
              shadow-[0_5px_20px_5px_rgba(193,131,243,0.2)]
              cursor-pointer
              rounded-full 
              flex items-center 
              justify-center"
              animate={{
                rotate: [360, 0],
                transition: {
                  duration: 8,
                  ease: "linear",
                  repeat: Infinity,
                  repeatDelay: 0,
                },
              }}
            >
              <div className="bg-white  mds:w-52 mds:h-52 w-28 h-28  rounded-full flex items-center justify-center">
                <div className="mds:ml-10 mt-9 mr-8 mb-9 ml-10">
                  <Image
                    src={"/play.svg"}
                    width={"85px"}
                    height={"85px"}
                    quality="100"
                    alt="ascot website animation"
                  />
                </div>
              </div>
            </motion.div>
          </motion.div>

          <motion.div
            className="absolute mds:top-7 top-0 right-12  bg-[#BE72F3] rounded-full mds:h-[22px] mds:w-[22px] h-[11px] w-[11px]"
            // animate={{ rotate: [0, 360] }}
            // d={path}
            variants={pathVariants}
            animate="move"
            transition={{ duration: 1 }}
          />
        </motion.div>
        <motion.div
          className="absolute mx-auto mds:w-[326px] mds:h-[326px] w-[170px] h-[170px] z-10"
          animate={{
            //   scale: [1, 1, 1, 1, 1],
            rotate: [0, 360],
            borderRadius: ["50%", "50%", "50%", "50%", "50%"],
          }}
          transition={{
            duration: 7,
            ease: "linear",
            times: [1],
            repeat: Infinity,
            repeatDelay: 0,
          }}
        >
          <div className="absolute  bg-[#36A9E1] mds:top-52 top-14 -z-10 orbit rounded-full mds:h-[18px] mds:w-[18px] w-[9px] h-[9px] "></div>
        </motion.div>
      </button>
    </>
  );
}
